<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Compañías</a>
  </div>
  <h1 class="ui header"><i class="icon building"></i><div class="content">Compañías</div></h1>
  <button v-if="role==='master'" class="ui basic button rightButton" v-on:click="goTo('/companies/add')">
    <i class="icon building"></i>Añadir Compañia
  </button>
  <div v-if="!companies" class="ui active centered inline loader"></div>
  <div v-if="companies" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <table class="ui very basic compact selectable collapsing  table">
          <thead>
            <tr>
              <th class="azpian">Lista de compañías</th>
              <th class="right aligned">
                <div class="ui category search">
                  <div class="ui icon input field">
                    <input class="prompt" type="text" v-model="search" placeholder="Buscar compañia" @change="filteredList">
                      <i class="search icon"></i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="company in companies" v-bind:key="company.id">
              <td>
                <h4 class="ui image header">
                  <img v-if="company.AdminCompany.url" class="ui tiny image" :src="company.AdminCompany.url">
                  <img v-if="!company.AdminCompany.url" class="ui tiny image" src="../../assets/name.png">
                  <div class="content">
                    <div class="header">{{company.AdminCompany.name}}</div>
                    <div class="sub header">{{company.AdminCompany.description}}
                  </div>
                </div>
              </h4>
              </td>
              <td>
                <div v-if="role=='master'" class="ui button" v-on:click="goTo('/companies/edit/' + company.AdminCompany.id)">Editar</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Companies',
  data() {
    return {
      companies: null,
      search: null,
      role: null, 
      imageUrl: null,
      images: null,
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role
    if (this.role==='master'||this.role==='admin') {
      this.getImages()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/companies?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
        this.getCompanies()
      })
      .catch((error) => {
        console.log('error getting images')
        console.log(error)
      })
    },
    async getCompanies() {
      await hapiickApi().post('/v2/companies', {
        admin_id: JSON.parse(localStorage.admin).id,
        soloActivas: true
      })
      .then(request => {
        this.fillCompanies(JSON.parse(JSON.stringify(request.data.data.companies)))
      })
      .catch(() => console.log('error getting companies'))
    },
    goTo(where) {
      this.$router.push(where)
    },
    fillCompanies(companies) {
      let allCompanies = []
      for (let i = 0; i < companies.length; i++) {
        let url = this.images.find((e) => {
          return (e.key === companies[i].AdminCompany.external_name)
        })
        if (url !== undefined) {
          companies[i].AdminCompany.url = url.url
        } else {
          companies[i].AdminCompany.url = null
        }
        allCompanies.push(companies[i])
      }
      this.companies = allCompanies
    },
    filteredList() {
      let clientlist= []
      if(this.search.length==0){
        this.getCompanies()
      }
      for (var i = 0; i < this.companies.length; i++) {
        if(this.companies[i].AdminCompany.name.toLowerCase().includes(this.search.toLowerCase()))
          clientlist.push(this.companies[i])
      }
      this.companies=clientlist
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Companies/Companies.vue